export default {
    init() {
        jQuery('.testimonial_slider').slick({
            dots: false,
            arrows: true,
            infinite: false,
			lazyLoad: 'ondemand',
            speed: 300,
            adaptiveHeight: true,
            centerMode: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: '<img class="a-left control-c prev slick-prev" src="/wp-content/uploads/2021/03/Union-13.png">',
            nextArrow: '<img class="a-right control-c next slick-next" src="/wp-content/uploads/2021/03/Union-1.png">',
            responsive: [{
                breakpoint: 768,
                settings: {
                    prevArrow: '<img class="a-left control-c prev slick-prev" src="/wp-content/uploads/2021/04/Union-13.png">',
                    nextArrow: '<img class="a-right control-c next slick-next" src="/wp-content/uploads/2021/04/Union-1.png">',
                },
            }],
        });
		jQuery('.locations_slider').slick({
            dots: false,
            arrows: false,
            infinite: false,
            speed: 300,
            adaptiveHeight: true,
			lazyLoad: 'ondemand',
            centerMode: false,
            slidesToShow: 5,
            slidesToScroll: 1,
            responsive: [{
                breakpoint: 768,
                settings: {
                    arrows: true,
                    centerMode: false,
                    slidesToShow: 1,
                    prevArrow: '<img class="a-left control-c prev slick-prev" src="/wp-content/uploads/2021/03/Union-13.png">',
                    nextArrow: '<img class="a-right control-c next slick-next" src="/wp-content/uploads/2021/03/Union-1.png">',
                },
            }],
        });
        jQuery('#navbar-primary .navbar-nav li.dropdown .nav-link').click(function(e) {
            if (jQuery(window).width() < 1200) {
                var grandparent = $(this).next();
                if (jQuery(this).hasClass('open1') && grandparent.hasClass('opened')) {
                    document.location.href = this.href;
                } else {
                    jQuery(this).addClass('open1');
                    jQuery('#navbar-primary .navbar-nav').find('i').removeClass('opened');
                    jQuery(this).next('.dropdown-toggle1').click();
                }
            } else {
                location.href = this.href;
            }
            e.preventDefault();
        });
        $('#select_search_cat').select2({
            closeOnSelect: true,
            placeholder: 'EXPLORE TOPICS',
            containerCssClass: 'wrap',
        });
        $('#select_search').select2({
            closeOnSelect: true,
            placeholder: 'EXPLORE TESTIMONIALS',
            containerCssClass: 'wrap',
        });
		$('#select_search_cat').change(function(){
             $('#searchform').submit();
        });
        $('#select_search').on('select2:select', function() {
            window.location.href = '' + $('#select_search').val();
        });

        jQuery('li.dropdown > .dropdown-toggle1').on('click', function(e) {
            var current = jQuery(this).next();
            var current1 = jQuery(this);
            var grandparent = jQuery(this).parent().parent();
            var cparent = jQuery(this).parent();
            grandparent.find('.dropdown-menu:visible').not(current).removeClass('show1');
            grandparent.find('.dropdown-toggle1').not(current1).removeClass('opened');
            jQuery(this).toggleClass('opened');
            current.toggleClass('show1');
            cparent.toggleClass('show-open');
            e.stopPropagation();
        });
        $('#callbtn').on('click', function(e) {
            e.preventDefault();
            $('#callbtn-dropdown').toggle();

        });
		jQuery('ul#menu-footer-menu li.dropdown .nav-link').click(function(e) {
            if (jQuery(window).width() < 768) {
                var grandparent = $(this).next();
                if (jQuery(this).hasClass('open1') && grandparent.hasClass('opened')) {
                    document.location.href = this.href;
                } else {
                    jQuery(this).addClass('open1');
                    jQuery('ul#menu-footer-menu').find('i').removeClass('opened');
                    jQuery(this).next('.dropdown-toggle1').click();
                }
            } else {
                location.href = this.href;
            }
            e.preventDefault();
        });

    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};


// WEBPACK FOOTER //
// ./scripts/routes/common.js